var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"請選擇項目","disabled":_vm.loading},on:{"change":_vm.beforeSelectItem},model:{value:(_vm.itemLocal),callback:function ($$v) {_vm.itemLocal=$$v},expression:"itemLocal"}},_vm._l((_vm.items),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }